import { Route, Routes } from "react-router-dom";

import BlogCreateScreen from "screens/App/CRM/Blog/BlogCreateScreen";
import BlogDetailScreen from "screens/App/CRM/Blog/BlogDetailScreen";
import BlogEditScreen from "screens/App/CRM/Blog/BlogEditScreen";
import BlogListScreen from "screens/App/CRM/Blog/BlogListScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const BlogRouter = () => {
  return (
    <Routes>
      <Route path="create" element={<BlogCreateScreen />} />
      <Route path=":id/detail" element={<BlogDetailScreen />} />
      <Route path=":id/edit" element={<BlogEditScreen />} />
      <Route path="list" element={<BlogListScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default BlogRouter;
